module.exports = __webpack_public_path__ + "static/img/banner.cad703fc.png";